import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Application, Loading, Module, Privilege } from '@fides/fides-react-components';
import { useGlobalConfigContext } from 'core/contexts/GlobalConfig';

const CreditTransfersAll = React.lazy(() => import('../../components/pages/CreditTransfers/All/CreditTransfersGrid'));
const CreditTransfersDeleted = React.lazy(() => import('../../components/pages/CreditTransfers/Deleted'));
const CreditTransfersUploadedFiles = React.lazy(() => import('../../components/pages/CreditTransfers/UploadedFiles'));

export const CreditTransfersRouter = () => {
  const { accessHelper, hasUserAppAccess } = useGlobalConfigContext();
  const hasAccessToAll =
    hasUserAppAccess(Application.EFTWEB) &&
    (accessHelper.hasPermissionForModule(Module.PAYMENT_VIEW, Privilege.GRANT) || accessHelper.isImpersonatedAsClient);
  const hasAccessToUploaded =
    hasUserAppAccess(Application.EFTWEB) &&
    (accessHelper.hasPermissionForModule(Module.PAYMENT_VIEW_UPLOADED, Privilege.GRANT) ||
      accessHelper.isImpersonatedAsClient);
  const hasAccessToDeleted =
    hasUserAppAccess(Application.EFTWEB) &&
    (accessHelper.hasPermissionForModule(Module.VIEW_DELETED_ORDER, Privilege.GRANT) ||
      accessHelper.isImpersonatedAsClient);

  const getRedirectPath = (): string => {
    if (hasAccessToAll) {
      return '/payments/all';
    }
    if (hasAccessToUploaded) {
      return '/payments/uploaded-files';
    }
    if (hasAccessToDeleted) {
      return '/payments/deleted';
    }
    return '/page-not-found';
  };

  return (
    <Switch>
      <Redirect from='/payments/' to={getRedirectPath()} exact />
      <Route path='/payments/all' exact>
        <Suspense fallback={<Loading />}>
          {hasAccessToAll ? <CreditTransfersAll /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/payments/deleted' exact>
        <Suspense fallback={<Loading />}>
          {hasAccessToDeleted ? <CreditTransfersDeleted /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/payments/uploaded-files' exact>
        <Suspense fallback={<Loading />}>
          {hasAccessToUploaded ? <CreditTransfersUploadedFiles /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Redirect to='/page-not-found' />
    </Switch>
  );
};
